// See: https://github.com/formatjs/react-intl/issues/1456 for more reasons why we use this
import PropTypes from "prop-types";

export const IntlPropType = PropTypes.shape({
  formatMessage: PropTypes.func.isRequired,
});

export default IntlPropType;
